<div id="academy-courses" class="page-layout simple">
  <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

      <div class="hero-text" fxLayout="row">
          <mat-icon class="ml-20 s-40">storage</mat-icon>
          <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
              líderes
          </h1>
      </div>

  </div>
<ng-container *ngIf="cargando">
  <div fxLayout="column" fxLayoutAlign="center center" style="margin-top:5%">
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_CARGA_INFO' | translate}}</h1>
  </div>
</ng-container>
<ng-container  *ngIf="!cargando">
  <div class="" fxLayout="column" fxLayoutAlign="space-between center">
            <ng-container *ngIf="filtrandoLide">
              <div fxLayout="column" fxLayoutAlign="space-between center" >
                <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                <h1>{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_FILT_INFO' | translate}}</h1>
              </div>
            </ng-container>
            <ng-container *ngIf="!filtrandoLide">
              <div class="" fxLayout="row" fxLayoutAlign="end end" style="width:70%">
                <!-- <p>{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_BTN_FILT' | translate}}</p> -->
                <mat-form-field appearance="outline" class="filtro">
                  <input matInput  [(ngModel)]='busquedaLiaders'(keyup)="getLideresCerAsociadoBusque()" placeholder="{{'LEADER_GO.SECCION_SELECT_LEADER.TEX_INDIC_BUSQ' | translate}}">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
              </div>
              <table mat-table [dataSource]="dataSource" class="tableInfo">
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_1' | translate}}</th>
                    <td mat-cell *matCellDef="let element" ><mat-icon class="ml-20">person</mat-icon> {{element.fullName}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="correo">
                    <th mat-header-cell *matHeaderCellDef> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_2' | translate}} </th>
                    <td mat-cell *matCellDef="let element" > {{element.email}} </td>
                  </ng-container>
                  <ng-container matColumnDef="area">
                    <th mat-header-cell *matHeaderCellDef> {{'LEADER_GO.SECCION_SELECT_LEADER.TH_3' | translate}} </th>
                    <td mat-cell *matCellDef="let element" > {{element.area}} </td>
                  </ng-container>
                  <ng-container matColumnDef="cupones">
                    <th mat-header-cell *matHeaderCellDef> Cupones </th>
                    <td mat-cell *matCellDef="let element" >
                      <div *ngFor="let item of element.coupons">
                        <p>({{item.cupon}})</p>
                    </div> </td>
                  </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="verInfor(1,row)">
          </tr>
        </table>

      </ng-container>
</div>
</ng-container>
